export function CelebrationStep() {
  return (
    <div className="flex flex-col items-center justify-center p-4 text-center">
      <h2 className="p-4 font-family-display text-4xl">Welcome to the movement!</h2>
      <p className="mb-4 max-w-md text-muted-foreground">
        We&apos;re thrilled to have you in our growing community working toward a healthier America.
        Keep an eye on your inbox&mdash;we&apos;ll show you how to get started and make the most of
        everything your membership unlocks.
      </p>
    </div>
  )
}
